import { Component } from "react";
import * as PropTypes from "prop-types";
import { Link } from "react-router-dom";
import ExternalLink from "../shared/ExternalLink";
import Popover from "../shared/Popover";
import PopoverItem from "../shared/PopoverItem";

const stopPropagation = e => e.stopPropagation();
export default class NavItem extends Component {
  static propTypes = {
    href: PropTypes.string,
    isActive: PropTypes.bool,
    label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    isDropDownActive: PropTypes.bool,
    dropdownContent: PropTypes.oneOfType([PropTypes.array, PropTypes.node]),
    linkTo: PropTypes.string,
    className: PropTypes.string,
    onClick: PropTypes.func,
    options: PropTypes.object,
    "aria-label": PropTypes.string
  };
  static defaultProps = {
    className: "",
    onClick: () => {
      return;
    }
  };

  render() {
    const {
      href,
      isActive,
      icon,
      label,
      className,
      linkTo,
      onClick,
      options,
      dropdownContent,
      isDropDownActive,
      "aria-label": ariaLabel
    } = this.props;
    const wrapperClassName = [
      "NavItem relative flex flex-col items-center justify-center px-[5px] mx-[5px] lg:px-[10px] lg:mx-[10px] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#4f46e5]",
      "[&_a]:text-sm [&_a]:min-[960px]:text-base [&_a]:text-gray-600 [&_a]:font-normal [&_a]:cursor-pointer [&_a]:leading-4 [&_a]:transition-colors [&_a]:duration-150 [&_a]:hover:text-indigo-500 [&_a]:hover:no-underline",
      className,
      isActive ? "is-active [&_a]:font-bold [&_a]:hover:text-gray-800 after:content-[''] after:absolute after:left-0 after:bottom-[-13px] after:w-full after:h-[3px] after:bg-indigo-500" : ""
    ].join(" ");

    const isStandaloneTrigger = !linkTo && !href && !options?.isButton;

    function linkify(linkContent, linkClassName, options = {}) {
      return linkTo ? (
        <Link className={linkClassName} to={linkTo}>
          {linkContent}
        </Link>
      ) : href ? (
        <ExternalLink href={href}>
          {linkContent}
        </ExternalLink>
      ) : options.isButton ? (
        <button className={`rounded-[3px] font-bold cursor-pointer py-[6px] px-[14px] pb-[7px] text-sm font-sans inline-block border-0 transition-all duration-200 outline-none relative leading-none ${options.buttonClassName || ""}`}>
          {linkContent}
        </button>
      ) : (
        <a>{linkContent}</a>
      );
    }

    return (
      <div
        onClick={e => {
          onClick(e);
          stopPropagation(e);
        }}
        className={wrapperClassName}
        role={isStandaloneTrigger ? "button" : undefined}
        aria-label={isStandaloneTrigger ? ariaLabel : undefined}
        tabIndex={isStandaloneTrigger ? 0 : undefined}
        onKeyDown={
          isStandaloneTrigger
            ? e => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  onClick(e);
                  stopPropagation(e);
                }
              }
            : undefined
        }
      >
        <div
          className={`HeaderContent-wrapper grow-0 shrink-0 ${
            isDropDownActive ? "[&_.icon]:rotate-180" : ""
          }`}
        >
          {icon ? linkify(icon, "HeaderLink grow-0 shrink-0") : null}
          {label ? linkify(label, "HeaderLink grow-0 shrink-0", options) : null}
          {dropdownContent ? (
            <Popover
              minWidth="170"
              visible={isDropDownActive}
              onClick={stopPropagation}
              content={
                Array.isArray(dropdownContent) ? (
                  <ul className="PopoverItem-wrapper">
                    {dropdownContent
                      .filter(x => x)
                      .map((contents, index) => (
                        <PopoverItem key={`item-${index}`} {...contents} />
                      ))}
                  </ul>
                ) : (
                  dropdownContent
                )
              }
            />
          ) : null}
        </div>
      </div>
    );
  }
}
